import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import Link from 'flarum/common/components/Link';
export default function addBadgesToUserCard() {
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    if (!user) return;
    if (app.forum.attribute('showBadgesOnUserCard') === false) return;
    const badgeCount = user.attribute('badgeCount') || 0;
    if (badgeCount === 0) return;
    const badgeName = user.attribute('primaryBadgeName');
    const badgeIcon = user.attribute('primaryBadgeIcon');
    if (!badgeName || !badgeIcon) return;
    const remainingCount = badgeCount - 1;
    items.add('cardBadges', m(Link, {
      href: app.route('user.badges', {
        username: user.username()
      }),
      className: "UserCardBadge"
    }, m("i", {
      className: badgeIcon
    }), m("span", {
      className: "UserCardBadge-name"
    }, badgeName), remainingCount > 0 && m("span", {
      className: "UserCardBadge-more"
    }, "+", remainingCount)), 15);
  });
}